import { useState, useEffect } from "react";

const CODES = ["+1", "+33", "+509", "+221", "+237", "+243", "+225", "+234", "+1876", "+252", "+44"];

const split = (v) => {
  const code = [...CODES].sort((a, b) => b.length - a.length).find((c) => (v || "").startsWith(c)) || "+1";
  return [code, (v || "").slice(code.length)];
};

export const PhoneInput = ({ value, onChange, testid = "phone-input" }) => {
  const [code, setCode] = useState(() => split(value)[0]);
  const [num, setNum] = useState(() => split(value)[1]);
  useEffect(() => { onChange(num ? code + num.replace(/\D/g, "") : ""); }, [code, num]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex gap-2">
      <select data-testid={`${testid}-code`} value={code} onChange={(e) => setCode(e.target.value)} aria-label="Country code"
        className="min-h-[48px] rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] px-3 text-base font-semibold">
        {CODES.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <input data-testid={testid} type="tel" inputMode="tel" autoComplete="tel-national" required value={num} onChange={(e) => setNum(e.target.value)}
        placeholder="514 555 0123" className="flex-1 min-w-0 min-h-[48px] rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] px-4 text-base" />
    </div>
  );
};
